import React, { FC } from "react";

const isServer = () => typeof window === `undefined`;

const NoSSR: FC = props => (isServer() ? null : <>{props.children}</>);

export default NoSSR;
